import { ReactElement, useEffect } from 'react';
import { FieldValues, useFormContext } from 'react-hook-form';
import debounceFunc from 'lodash/debounce';

interface IProps<TFieldValues extends FieldValues = FieldValues> {
  debounce?: number;
  initialValues: TFieldValues;
  onSubmit: (values: TFieldValues) => void;
  setLoading?: (loading: boolean) => void;
}

const AutoSubmit = <TFieldValues extends FieldValues = FieldValues>({
  debounce = 0,
  initialValues,
  onSubmit,
  setLoading,
}: IProps<TFieldValues>): ReactElement => {
  const {
    handleSubmit,
    watch,
    formState: { isSubmitting },
  } = useFormContext<TFieldValues>();

  const handleSubmitForm = debounceFunc(() => handleSubmit(onSubmit)(), debounce);

  useEffect(() => {
    const subscription = watch(values => {
      if (values === initialValues || isSubmitting) return;
      setLoading?.(true);
      handleSubmitForm();
    });

    return () => subscription.unsubscribe();
  }, [handleSubmitForm, initialValues, isSubmitting, watch, setLoading]);

  return null;
};

export default AutoSubmit;
